import { Button, Grid, Stack } from '@mui/material';
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import BlockData from '../../../models/BlockData';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import LinkButton from '../../Buttons/LinkButton';
import BlockButtonListData from './BlockButtonListData';
import CloseButton from '../../Buttons/Close';
import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';
import GridWithSettings from '../../Layout/GridWithSettings';

export interface BlockButtonListProps extends BlockProps {
  blockData: BlockData[]
}

function BlockButtonList({
  data, isEditing, isTemplate, editHandler, blockData,
}: BlockButtonListProps) {
  const props = (data.data as BlockButtonListData);

  const handleAddButton = () => {
    props.buttonList.push(BlockComponentButton.getDefault());
    editHandler(data.id, props);
  };

  const buttonMenu = useMemo(() => {
    if (props.buttonList && props.buttonList.length > 0) {
      return props.buttonList.map((button, index) => (
        <Grid key={uuid()} minWidth={150} item xs={3} sx={Utils.hoverBorder(isEditing)}>
          <CloseButton
            show={isEditing}
            updateHandler={() => {
              props.buttonList.splice(index, 1);
              editHandler(data.id, props);
            }}
          />
          <LinkButton
            button={button}
            blockData={blockData}
            isEditable={isEditing && !isTemplate}
            isTemplate={isTemplate}
            updateHandler={(item) => {
              props.buttonList[index] = item;
              editHandler(data.id, props);
            }}
          />
        </Grid>
      ));
    }
    return [];
  }, [blockData, data.id, editHandler, isEditing, isTemplate, props]);

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        overflow: 'hidden',
        p: 1.5,
      }}
    >
      <GridWithSettings
        settings={props.settings}
        isEditing={isEditing}
        direction="row"
        updateHandler={(settings) => {
          props.settings = settings;
          editHandler(data.id, props);
        }}
      >
        {buttonMenu}
      </GridWithSettings>
      {isEditing && (
        <Stack spacing={0} sx={{ border: '1px dashed lightGray', marginTop: '12px', width: 'calc(100% - 24px)' }}>
          <Button color="primary" onClick={handleAddButton}>
            <AddCircleRoundedIcon />
          </Button>
        </Stack>
      )}
    </Grid>
  );
}

export default BlockButtonList;
